import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import { OnboardingV2Service } from '@forwardflow/services/onboardingV2.service'
import SubscriptionService from '@forwardflow/services/SubscriptionService'
import useSWR from 'swr'
import { gated } from '@forwardflow/utils/sandbox'

export const useGetFubUsers = (
   organizationId: string,
   limit?: number,
   page?: number,
   isFUBConnected?: boolean
) => {
   // Nothing to fetch without an organization, and nothing in the sandbox.
   return useSWR(
      gated(
         organizationId
            ? [QUERY_KEYS.GET_FUB_USERS, { organizationId, limit, page, isFUBConnected }]
            : null
      ),
      () => OnboardingV2Service.getFubUsers({ organizationId, limit, page })
   )
}

export const useGetFubStages = (
   orgId: string,
   limit?: number,
   page?: number,
   isFUBConnected?: boolean,
   search?: string
) => {
   return useSWR(
      orgId
         ? [
              QUERY_KEYS.GET_FUB_STAGES,
              {
                 orgId,
                 limit: limit || undefined,
                 page: page || undefined,
                 isFUBConnected,
                 search,
              },
           ]
         : null,
      () =>
         OnboardingV2Service.getFubStages({
            organizationId: orgId,
            limit: limit || undefined,
            page: page || undefined,
            search,
         }),
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: true,
         dedupingInterval: 5000,
      }
   )
}

export const useGetPeopleTags = (
   orgId: string,
   page?: number,
   limit?: number,
   isFUBConnected?: boolean,
   search?: string
) => {
   return useSWR(
      orgId && isFUBConnected
         ? [
              QUERY_KEYS.GET_PEOPLE_TAGS,
              { orgId, page, limit, isFUBConnected, search },
           ]
         : null,
      () => OnboardingV2Service.getPeopleTags({ orgId, page, limit, search }),
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: true,
         dedupingInterval: 5000,
      }
   )
}

export const useSearchAvailableAreaCodes = (search: string) => {
   return useSWR(
      search?.trim()
         ? [QUERY_KEYS.GET_AVAILABLE_AREA_CODES, { search }]
         : null,
      () => SubscriptionService.getAvailableAreaCodes(search),
      {
         revalidateOnFocus: false,
         dedupingInterval: 5000,
      }
   )
}

export const useGetSuggestedStageMappings = (
   stages: { stageId: number; stageName: string }[],
   tags: { tagId: number; tagName: string }[],
   enabled: boolean = true
) => {
   return useSWR(
      enabled && (stages.length > 0 || tags.length > 0)
         ? [QUERY_KEYS.GET_SUGGESTED_STAGE_MAPPINGS, { stages, tags }]
         : null,
      () => OnboardingV2Service.getSuggestedStageMappings({ stages, tags }),
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: false,
         dedupingInterval: 10000,
      }
   )
}
